// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"177":"96e3c319","379":"cd98781b","795":"23aa1e9a"}[chunkId] + ".css";
};